import { useState } from "react";
import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  Alert,
  Link as MuiLink,
} from "@mui/material";
import {
  Link as RouterLink,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { resetPassword } from "../Services/authService";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (newPassword.length < 8) {
      setError("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    setLoading(true);
    try {
      await resetPassword(token, newPassword);
      setSuccess("Votre mot de passe a été mis à jour. Redirection vers la connexion...");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        "Impossible de réinitialiser le mot de passe. Le lien est peut-être expiré.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", p: 2 }}>
        <Paper sx={{ p: 4, width: 400 }}>
          <Typography variant="h6" gutterBottom>Lien invalide</Typography>
          <Alert severity="error" sx={{ mt: 1 }}>
            Aucun token fourni. Veuillez utiliser le lien reçu par email ou redemander un lien.
          </Alert>
          <Box sx={{ mt: 2, textAlign: "center" }}>
            <MuiLink component={RouterLink} to="/forgot-password" variant="body2">
              Demander un nouveau lien
            </MuiLink>
          </Box>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", p: 2 }}>
      <Paper sx={{ p: 4, width: 400 }}>
        <Typography variant="h6" gutterBottom>Nouveau mot de passe</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Choisissez un nouveau mot de passe (8 caractères minimum).
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Nouveau mot de passe"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            fullWidth
            margin="normal"
            required
            disabled={loading || Boolean(success)}
          />
          <TextField
            label="Confirmer le mot de passe"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            fullWidth
            margin="normal"
            required
            disabled={loading || Boolean(success)}
          />
          {error && (
            <Alert severity="error" sx={{ mt: 1 }}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert severity="success" sx={{ mt: 1 }}>
              {success}
            </Alert>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            disabled={loading || Boolean(success)}
          >
            {loading ? "Mise à jour..." : "Réinitialiser le mot de passe"}
          </Button>
        </form>
        <Box sx={{ mt: 2, textAlign: "center" }}>
          <MuiLink component={RouterLink} to="/login" variant="body2">
            Retour à la connexion
          </MuiLink>
        </Box>
      </Paper>
    </Box>
  );
}
